import { useEffect } from "react";
import classNames from "classnames";
import Cookies from "js-cookie";

import { useUserData } from "lib/store/user";
import { updateZephrUserProfile } from "lib/fetchers/zephr/customFields";
import { Hero } from "./components/hero";
import { Benefits } from "./components/benefits";
import { Comparison } from "./components/comparison";
import { Faq } from "./components/faq";
import { FooterCta } from "./components/footerCta";
import { datadogLogger } from "lib/datadog/logger";

const innerContainerClasses = classNames(
  "mx-auto w-100 max-w-[1140px] px-5 pb-10 md:pb-[70px] pt-[30px] md:pt-[40px] lg:pt-[60px] md:mx-auto lg:max-w-[1220px] lg:px-0"
);

export const SiftedForAngelsView = ({ data }) => {
  const { readerSubscriptionLevel } = useUserData();

  useEffect(() => {
    window.tp.push([
      "addHandler",
      "checkoutComplete",
      async (params) => {
        // Changed from __utp to blaize_session for Zephr
        const loginCookie = Cookies.get("blaize_session");

        if (!loginCookie) {
          datadogLogger.error(`No login cookie found for user: ${params.uid}`);
          return;
        }

        const res = await updateZephrUserProfile(
          {
            wants_main_newsletter: true,
            "would-like-futureproof-newsletter": true,
          },
          loginCookie
        );

        if (!res.success && res.errors && res.errors.length > 0) {
          datadogLogger.error(
            `Error updating custom fields for user: ${params.uid}`,
            res.errors
          );
        }
      },
    ]);
  }, []);

  const isRegistered =
    readerSubscriptionLevel === "registered" ||
    readerSubscriptionLevel === "member" ||
    readerSubscriptionLevel === "angel" ||
    readerSubscriptionLevel === "startup" ||
    readerSubscriptionLevel === "pro";
  const isUnregistered = readerSubscriptionLevel === "unregistered";

  const loginUrl = () =>
    `/members/login?${encodeURIComponent("redirectUrl")}=${encodeURIComponent(window.location.href)}`;

  const onButtonClick = () => {
    // Zephr migration: trigger Zephr paywall/upgrade flow for registered users
    if (isRegistered) {
      if (window.Zephr && typeof window.Zephr.showPaywall === "function") {
        window.Zephr.showPaywall();
      } else {
        // Fallback: Zephr failed to load or showPaywall is unavailable
        alert(
          "Sorry, we couldn't load the paywall at this time. Please try again later or contact support if the issue persists."
        );
      }
    }
    if (isUnregistered) {
      window.location.assign(loginUrl());
    }
  };

  return (
    <main className="w-100 overflow-x-hidden bg-[#F4F4F6] pt-[65px] text-black-rock">
      <div className={innerContainerClasses}>
        <Hero
          data={data}
          readerSubscriptionLevel={readerSubscriptionLevel}
          onButtonClick={onButtonClick}
        />
        <Benefits data={data} />
        <Comparison
          data={data}
          readerSubscriptionLevel={readerSubscriptionLevel}
          onButtonClick={onButtonClick}
        />
        <Faq data={data} />
      </div>
      <FooterCta
        data={data}
        readerSubscriptionLevel={readerSubscriptionLevel}
        onButtonClick={onButtonClick}
      />
    </main>
  );
};
